angular.module('mercury.modules.reports.reconciliations')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.ReconciliationOverview', {
    url: '/reconciliations/overview?report',
    templateUrl: 'modules/reports/reconciliations/overview.tpl.html',
    controller: 'ReportsReconciliationOverviewCtrl'
  });

  $stateProvider.state('Reports.ReconciliationCashups', {
    url: '/reconciliations/cashups?report',
    templateUrl: 'modules/reports/reconciliations/cashups.tpl.html',
    controller: 'ReportsReconciliationCashupsCtrl'
  });

  $stateProvider.state('Reports.ReconciliationTenders', {
    url: '/reconciliations/tenders?report',
    templateUrl: 'modules/reports/reconciliations/tenders.tpl.html',
    controller: 'ReportsReconciliationTendersCtrl'
  });

  $stateProvider.state('Reports.ReconciliationTenderSurcharges', {
    url: '/reconciliations/tender-surcharges?report',
    templateUrl: 'modules/reports/reconciliations/surcharges.tpl.html',
    controller: 'ReportsReconciliationTenderSurchargesCtrl'
  });

  $stateProvider.state('Reports.ReconciliationTenderDetails', {
    url: '/reconciliations/tenders/:id?report',
    templateUrl: 'modules/reports/reconciliations/tenderdetails.tpl.html',
    controller: 'ReportsReconciliationTenderDetailsCtrl'
  });

  $stateProvider.state('Reports.ReconciliationTips', {
    url: '/reconciliations/tips?report',
    templateUrl: 'modules/reports/reconciliations/tips.tpl.html',
    controller: 'ReportsReconciliationTipsCtrl'
  });
}]);
